import { render, staticRenderFns } from "./AddOrganizationModal.vue?vue&type=template&id=39229fb2&scoped=true&"
import script from "./AddOrganizationModal.vue?vue&type=script&lang=ts&"
export * from "./AddOrganizationModal.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "39229fb2",
  null
  
)

export default component.exports